/* istanbul ignore file */
// ignore this file because it's just wrapping parsePhoneNumberFromString
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const normalizedPhoneNumber = (value, locale) => {
  const phoneNumber = parsePhoneNumberFromString(value, locale);
  if (!phoneNumber) {
    return value;
  }
  return phoneNumber.formatInternational();
};
